import { useProfileContext } from "../contexts/ProfileContext";
import { Role } from "../core/models/entities/Role";

export function useCartHidden(): boolean {
  const { role, organization } = useProfileContext();
  return role === Role.EndUser && organization?.hidePrices === true;
}
